export default {
    getPartialPaymentInformationPopup: (state) => {
        return state.isShowPartialPaymentInformationPopup;
    },
};
